import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderDetailsFragment = { __typename?: 'FolderAsset', id: string, name: string, isRestrictedDescendant?: boolean | null, itemCount?: number | null, filesize: number, displayDate?: string | null, restricted?: boolean | null, userProvidedColor?: string | null, parent?: { __typename?: 'AudioAsset', id: string } | { __typename?: 'DocumentAsset', id: string } | { __typename?: 'FileAsset', id: string } | { __typename?: 'FolderAsset', id: string } | { __typename?: 'ImageAsset', id: string } | { __typename?: 'InteractiveAsset', id: string } | { __typename?: 'InteractiveLiveAsset', id: string } | { __typename?: 'ModelAsset', id: string } | { __typename?: 'UnsupportedAsset', id: string } | { __typename?: 'VersionStackAsset', id: string } | { __typename?: 'VideoAsset', id: string } | null, project?: { __typename?: 'Project', id: string } | null };

export const FolderDetails = /*#__PURE__*/ gql`
    fragment FolderDetails on FolderAsset {
  id
  name
  isRestrictedDescendant
  itemCount
  filesize
  displayDate
  parent {
    id
  }
  project {
    id
  }
  restricted
  userProvidedColor
}
    ` as unknown as DocumentNode<FolderDetailsFragment, unknown>;

        

        
export const useFolderDetailsFragment = (
  input: string | Omit<UseFragmentOptions<FolderDetailsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderDetailsFragment>({
    fragment: FolderDetails,
    fragmentName: 'FolderDetails',
    ...options,
  });
};
  
        